import React from 'react';
import {Control, FieldErrors, UseFormRegister} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import InputUrl from 'shared/ui/Input/InputUrl';
import InputText from 'shared/ui/Input/InputText';
import {TagsChipField} from 'entities/monitor';
import IHttpMonitorOutput from 'features/http/model/HttpMonitor/IHttpMonitor';
import CreateHttpMonitorType from 'features/http/model/HttpMonitor/CreateHttpMonitorType';

import styles from './InputNameBlock.module.scss';

interface IInputNameBlockProps {
    item: IHttpMonitorOutput | undefined;
    register: UseFormRegister<any>;
    control: Control<any>;
    errors: FieldErrors<CreateHttpMonitorType>;
}

const InputNameBlock: React.FC<IInputNameBlockProps> = ({
    item,
    register,
    control,
    errors,
}) => {
    const isNew = !item;

    return (
        <div className={isNew ? styles.wrapper : ''}>
            <FormGroupWithError
                error={errors?.url?.message}
                className={styles.formGroup}
            >
                <InputUrl
                    register={register}
                    defaultValue={item?.url_human_readable}
                    name="url"
                    placeholder="https://example.com"
                    control={control}
                />
            </FormGroupWithError>

            <FormGroupWithError
                error={errors?.name?.message}
                className={styles.formGroup}
            >
                <InputText
                    defaultValue={item?.name}
                    name="name"
                    placeholder={t`Короткое название`}
                    register={register}
                    control={control}
                    validate={false}
                />
            </FormGroupWithError>

            <TagsChipField
                control={control}
                error={errors?.tags?.message}
                className={styles.formGroup}
            />
        </div>
    );
};

export default InputNameBlock;